import { Injectable } from '@nestjs/common';
import { TrimsDTO } from './trims.dto';

import { Trims } from '../trims.entity';

@Injectable()
export class TrimsAdapter {
    
    public convertDtoToEntity(TrimsDTO: TrimsDTO,  isUpdate: boolean = false) : Trims {
        const trims = new Trims();
        trims.trimsId=TrimsDTO.trimsId;
        trims.trimName=TrimsDTO.trimName;
       

        trims.isActive=TrimsDTO.isActive==undefined?true:TrimsDTO.isActive;
        if (isUpdate) {
          trims.updatedUser = TrimsDTO.updatedUser;
        } else {
          trims.isActive = true;
          trims.createdUser =TrimsDTO.createdUser;
        }
       return trims;
      }
      public convertEntityToDto(trimsObject: Trims): TrimsDTO {
        const trimsDTO= new TrimsDTO;
        trimsDTO.trimsId=trimsObject.trimsId;
        trimsDTO.trimName=trimsObject.trimName;
      
        trimsDTO.isActive=trimsObject.isActive;
        trimsDTO.createdAt=trimsObject.createdAt;
        trimsDTO.updatedAt=trimsObject.updatedAt;
        trimsDTO.createdUser=trimsObject.createdUser;
        trimsDTO.updatedUser=trimsObject.updatedUser;
        trimsDTO.versionFlag=trimsObject.versionFlag;
        return trimsDTO;
      }
    }
